import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Dialog, DialogTitle } from "@material-ui/core/";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import Close from "@material-ui/icons/Close";

const InputModal = ({ setOpen, setOpenVariable, variables, action }) => {
  const { t } = useTranslation();

  function handleClose() {
    setOpen(false);
  }

  return (
    <Dialog id="autom-addNew-modal" data-test="autom-add-new" open={true} PaperProps={{
      style: {
        minWidth: 400
      }
    }}>
      <DialogTitle id="alert-dialog-title">
        <div id="about-title">
          {t("CONTENT.AUTOMS-LIST.TYPE-INPUT")}
          <Button data-test="cancelautom-button" onClick={handleClose}>
            <Close />
          </Button>
        </div>
      </DialogTitle>
      <DialogContent>
        <div style={{ textAlign: "center", marginTop: 20 }}>
          <div className="form-element">
            <TextInput
              inputName="inputValue"
              action={action}
              setOpenVariable={setOpenVariable}
              variables={variables}
            />
          </div>
        </div>
      </DialogContent>
      <DialogActions
        style={{
          justifyContent: "center",
          padding: "8px 24px 16px 24px",
        }}
      >
        <div
          onClick={handleClose}
          data-test="createautom-button"
          style={{
            backgroundColor: "#162436",
            borderRadius: "4px",
            color: "#fff",
            boxShadow: "0px 0px 8px -3px rgba(0, 0, 0, 0.25)",
            cursor: "pointer",
            padding: "5px 14px"
          }}
        >
          {t("CONTENT.AUTOMS-LIST.SAVE")}
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default InputModal;
